<!--
* @FileDescription: 行政-周计划清单
* @Author: xuboshi
* @Date: 2021-06-24
* @LastEditors: xuboshi
* @LastEditTime: 2021-06-24
-->
<template>
	<div class="detailList">
		<el-row type="flex" class="margin-bottom-sm" justify="end" v-if="editable">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAddRow">新增一行</el-button>
      <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteRows">删&nbsp;除</el-button>
		</el-row>
		<el-form ref="ruleForm" :model="detailList" size="small">
			<el-form-item class="is-hidden" prop="dataList" :show-message="false"></el-form-item>
			<!-- 此行注释不保留 高度为内容10行时的表格高度，自行计算 -->
			<el-table
				ref="multipleTable"
				:data="detailList.dataList"
				:row-class-name="tableRowClassName"
				@row-click="handleRowClick"
				@selection-change="handleSelectionChange"
				stripe
				border
			>
				<el-table-column type="selection" width="48" align="center" :selectable="row => !(protectMain && row.concernedOrNot)"></el-table-column>
				<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
				<el-table-column prop="linkmanName" label="联系人名称" width="140" label-class-name="table-required" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].linkmanName'" :rules="rules.required">
							<el-input v-model="row.linkmanName" placeholder="请输入" maxlength="50" :disabled="protectMain && row.concernedOrNot" />
						</el-form-item>
					</template>
				</el-table-column>
				<el-table-column prop="linkmanJob" label="联系人职务" width="180" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].linkmanJob'">
							<el-input v-model="row.linkmanJob" placeholder="请输入" maxlength="50" :disabled="protectMain && row.concernedOrNot" />
						</el-form-item>
					</template>
				</el-table-column>
				<el-table-column prop="linkmanTelephone" label="联系人电话" width="160" label-class-name="table-required" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].linkmanTelephone'" :rules="rules.required">
							<el-input v-model="row.linkmanTelephone" placeholder="请输入" maxlength="11" :disabled="protectMain && row.concernedOrNot" />
						</el-form-item>
					</template>
				</el-table-column>
				<el-table-column prop="linkmanEmail" label="联系人邮箱" width="220" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].linkmanEmail'">
							<el-input v-model="row.linkmanEmail" placeholder="请输入" maxlength="50" :disabled="protectMain && row.concernedOrNot" />
						</el-form-item>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].remark'">
							<el-input v-model="row.remark" placeholder="请输入" maxlength="500" show-word-limit :disabled="protectMain && row.concernedOrNot" />
						</el-form-item>
					</template>
				</el-table-column>
        <el-table-column prop="concernedOrNot" label="作为注册号" width="100" class-name="is-input">
					<template #default="{ row, $index }">
						<el-form-item :prop="'dataList[' + $index + '].concernedOrNot'">
              <el-switch v-model="row.concernedOrNot" @change="handleChangeMain(row, $index)" :disabled="protectMain" />
						</el-form-item>
					</template>
				</el-table-column>
			</el-table>
		</el-form>
	</div>
</template>

<script>
import { getLinkmanById } from '@/api/supplier';
import { isValid, isNotValid, isEmpty, handleRows } from '@/utils';

export default {
	name: 'detailList',
	props: {
		// 可否编辑
		editable: {
			type: Boolean,
			default: true
		},
    // 是否保护主联系人
    protectMain: {
      type: Boolean,
      default: false
    }
	},
	data() {
		return {
			isLoaded: false, // 是否已加载
			detailList: {
				dataList: [] // 清单数据
			},
			loading: false, // 是否局部加载
			keywordSearch: '', // 搜索关键词
			multipleSelection: [], // 选中项
			removed: [], // 删除项清单
			model: {
				linkmanName: '', //联系人名称
				linkmanJob: '', // 联系人职务
				linkmanTelephone: '', // 联系人电话
				linkmanEmail: '', // 联系人邮箱
				remark: '', // 备注
				concernedOrNot: false, // 是否为注册号
			},
			limit: {
				pagination: false
			},
			required: ['linkmanName', 'linkmanTelephone'],
			rules: {
				dataList: [
					{
						validator: (rule, value, callback) => {
							// 遍历判断是否拥有有效数据
							let index = value.findIndex(obj => obj.insertType !== 'ADD' || isValid(obj, this.required));
							if (index === -1) {
								callback(new Error('请完善清单！'));
							} else {
								callback();
							}
						}
					}
				],
				required: [{ required: true, message: '请输入' }],
			}
		};
	},
  computed: {
    hasMain() {
      return this.detailList.dataList.findIndex(obj => obj.concernedOrNot === true) > -1;
    }
  },
	methods: {
		/**
		 * @description: 组件手动加载
		 * @param {String} entityId 单据id
		 * @param {Boolean} loading 是否局部加载
		 */
		load(entityId, loading) {
			if (entityId == null || this.isLoaded) {
				return;
			}
			this.getDetailList(entityId, loading);
		},
		/**
		 * @description: 根据id获取清单数据
		 * @param {String} id 数据id
		 * @param {Boolean} loading 是否局部加载
		 */
		getDetailList(id, loading) {
			this.loading = loading;
			getLinkmanById(id, this.limit, { loading: loading }).then(res => {
				this.loading = false;
				if (res != null && res.code === '00000') {
					this.isLoaded = true;
					if (res.rows && res.rows.length > 0) {
						this.detailList.dataList = res.rows;
					} else {
						// 新增一行
						this.handleAddRow('detailList');
					}
				}
			});
		},
		/**
		 * @description: 附件必填校验
		 */
		validate() {
			const promise = new Promise((resolve, reject) => {
				this.$refs['ruleForm'].validate(vaild => {
					vaild ? resolve(vaild) : this.$message.error('请完善清单！');
				});
			});
			return promise;
		},
		/**
		 * @description: 获取处理好的附件清单
		 */
		getStoreRows() {
			return handleRows(this.detailList.dataList, this.removed);
		},
		/**
		 * @description: 给表格每行数据增加下标
		 * @param {Object} row 行数据
		 * @param {Number} rowIndex 下标
		 */
		tableRowClassName({ row, rowIndex }) {
			row.rowIndex = rowIndex;
			if (this.multipleSelection.findIndex(obj => obj.rowIndex === rowIndex) > -1) {
				return 'current-row';
			}
		},
		/**
		 * @description: 更改选中项
		 * @param {Array} selection 选中项
		 */
		handleSelectionChange(selection) {
			this.multipleSelection = selection;
		},
		/**
		 * @description: 点击表格行
		 * @param {Objject} row 选中行
		 */
		handleRowClick(row) {
			// 禁用行
			// if (row.rowIndex === 0) {
			// 	return;
			// }
			if (row.insertType !== 'ADD') {
				row.insertType = 'EDIT';
			}
			this.$refs['multipleTable'].clearSelection();
			this.$refs['multipleTable'].toggleRowSelection(row);
		},
		/**
		 * @description: 指定表格新增一行
		 */
		handleAddRow() {
			let model = Object.assign({ insertType: 'ADD' }, this.model);
      if (!this.hasMain) model.concernedOrNot = true;
			this.detailList.dataList.push(model);
		},
		/**
		 * @description: 指定表格批量删除
		 */
		handleDeleteRows() {
			this.multipleSelection.sort((a, b) => {
				return b.rowIndex - a.rowIndex;
			});
			for (let i = 0, len = this.multipleSelection.length; i < len; i++) {
				let row = this.multipleSelection[i];
				if (row.insertType !== 'ADD') {
					this.removed.push(row);
				}
				this.detailList.dataList.splice(row.rowIndex, 1);
			}
		},
    /**
     * @description: 切换主联系人
     * @param {Object} row 行数据
     * @param {Number} index 行索引
     */
    handleChangeMain(row, index) {
      if (row.concernedOrNot) {
        this.detailList.dataList.forEach(item => {
          if (item.rowIndex !== index) item.concernedOrNot = false;
        });
      } else {
        row.concernedOrNot = true;
        this.$message.error('提示：必须有一条数据作为注册号！');
      }
    }
	}
};
</script>

<style scoped="scoped" lang="less">
.detailList {
  :deep(.el-table) {
    .el-table__fixed-header-wrapper .cell,
    .el-table__header-wrapper .cell {
      font-family: @font-medium;
      color: @default-color;
    }
    th.el-table__cell.table-required>div::before {
      content: '*';
      color: red;
      margin-right: 2px;
    }
    .el-table__cell {
      padding: 6px 0;
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>

